

export default {
    name: "ChatSayLink",
    props: {
        linkUrl: String,
    },
    methods: {
        onCopy() {
            this.$copy(this.linkUrl)
        },
        onOpen() {
            window.location.href = this.linkUrl
        }

    }
}
